<template>
    <div v-loading="$parentInfo.studentCourseRecord.dialog_ChangeCourse.loading">
        <div class="card-body">
            <el-form label-position=right label-width="80px" style="top:10px">
                <el-row :span="20">
                    <el-col :span="10">
                        <el-form-item label="可换课时">
                            <el-input v-model="$parentInfo.studentCourseRecord.dialog_ChangeCourse.retire_period"
                                      :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="单价">
                            <el-input
                                    v-model="$parentInfo.studentCourseRecord.dialog_ChangeCourse.studentPeriod.unit_period_price"
                                    :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="20">
                    <el-col :span="10">
                        <el-form-item label="换课原因">
                            <el-select v-model="$parentInfo.studentCourseRecord.dialog_ChangeCourse.reason_id"
                                       placeholder="请选择原因">
                                <el-option
                                        v-for="item in options"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="具体原因">
                            <el-input v-model="$parentInfo.studentCourseRecord.dialog_ChangeCourse.reason"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" size="small" @click="handleUpdateStudentPeriod()"
                       :loading="$parentInfo.studentCourseRecord.dialog_ChangeCourse.button_loading">确认更换
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Dialog_ChangeCourse",
        data() {
            return {
                options: [
                    {'id': 1, 'name': '老师授课原因'},
                    {'id': 2, 'name': '非老师原因'},
                ],
            };
        },
        computed: {},
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentCourseRecord.dialog_ChangeCourse.loading = true;
            this.$parentInfo.studentCourseRecord.dialog_ChangeCourse.reason = '';
            this.$parentInfo.studentCourseRecord.dialog_ChangeCourse.reason_id = '';
            this.handleShowStudentPeriod();
        },
        methods: {
            handleShowStudentPeriod() {
                this.$wApi.send(this.$parentInfo.path, 'showStudentPeriod', {
                    'period_id': this.$store.state.modal.data.studentPeriod_id,
                });
            },
            handleUpdateStudentPeriod() {
                if (this.$parentInfo.studentCourseRecord.dialog_CancelCourse.retire_period === 0) {
                    this.$message({
                        showClose: true,
                        message: '剩余课时为0，无法换课',
                        type: 'warning'
                    });
                } else {
                    this.$parentInfo.studentCourseRecord.dialog_ChangeCourse.button_loading = true;

                    this.$wApi.send(this.$parentInfo.path, 'changeStudentPeriod', {
                        'period_id': this.$store.state.modal.data.studentPeriod_id,
                        'student_id': this.$parentInfo.student_id,
                        //换课:原来的课
                        'originalClass_id': this.$store.state.modal.data.originalClass_id,
                        'change_reason': this.$parentInfo.studentCourseRecord.dialog_ChangeCourse.reason,
                        'change_reason_id': this.$parentInfo.studentCourseRecord.dialog_ChangeCourse.reason_id,
                        'cart_type': 'change',
                    });
                }
            },
        }
    };
</script>

<style>
</style>
